// 支持的货币类型
export type Currency =
  | "USD"
  | "SGD"
  | "EUR"
  | "GBP"
  | "AUD"
  | "CAD"
  | "JPY"
  | "CNY";

// 货币符号映射
export const CURRENCY_SYMBOLS: Record<Currency, string> = {
  USD: "$",
  SGD: "$",
  EUR: "€",
  GBP: "£",
  AUD: "$",
  CAD: "C$",
  JPY: "¥",
  CNY: "¥",
};

// 货币格式化选项
export interface CurrencyFormatOptions {
  showSymbol?: boolean;
  showCode?: boolean;
  decimals?: number;
  locale?: string;
}

/**
 * 获取货币符号
 * @param currency 货币代码
 * @returns 货币符号
 */
export const getCurrencySymbol = (currency: Currency): string => {
  return CURRENCY_SYMBOLS[currency] || currency || "";
};

/**
 * 格式化价格显示
 * @param price 价格数值
 * @param currency 货币代码
 * @param options 格式化选项
 * @returns 格式化后的价格字符串
 */
export const formatCurrency = (
  price: number,
  currency: Currency,
  options: CurrencyFormatOptions = {}
): string => {
  if (
    price === null ||
    price === undefined ||
    (typeof price === "string" && (price as string).trim() === "")
  ) {
    return "";
  }

  const {
    showSymbol = true,
    showCode = false,
    decimals = 0,
    locale = "en-US",
  } = options;

  // 格式化数字
  const formattedNumber = price.toLocaleString(locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });

  // 构建显示字符串
  let result = formattedNumber;

  if (showSymbol) {
    result = `${getCurrencySymbol(currency)}${result}`;
  }

  if (showCode) {
    result = `${result} ${currency}`;
  }

  return result;
};

/**
 * 检查是否为有效的货币代码
 * @param currency 货币代码
 * @returns 是否为有效货币
 */
export const isValidCurrency = (currency: string): currency is Currency => {
  return currency in CURRENCY_SYMBOLS;
};

/**
 * 获取所有支持的货币列表
 * @returns 支持的货币数组
 */
export const getSupportedCurrencies = (): Currency[] => {
  return Object.keys(CURRENCY_SYMBOLS) as Currency[];
};
